import React, { useState } from 'react';
import './Projects.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ProjectDetailsModal from '../../Shared/Modals/ProjectDetails';
import { useNavigate } from 'react-router-dom';
import ProjectSnapshot from "../../Shared/ProjectSnapshot/ProjectSnapshot";
import projectData from '../../../projectData';


const Projects = () => {
    const navigate = useNavigate();
    const [projectsInfo] = useState(projectData.slice(0, 3));
    const [modalIsOpen, setIsOpen] = useState(false);
    const [project, setProject] = useState({});
    function openModal(pd) {
        setIsOpen(true);
        setProject(pd);
    }

    function closeModal() {
        setIsOpen(false);
    }
    return (
        <section id="projects" className="projects mt-5 pt-4 pb-3">
            <div className="container">
                <div className="section-header mb-5 text-center">
                <h2 className="title">My Projects</h2>
                <div className="portfolio-note mx-auto" data-aos="fade-up">
                    <FontAwesomeIcon icon={faInfoCircle} className="portfolio-note-icon" />
                    <div className="portfolio-note-content">
                        Most of these projects feature my earlier work, primarily developed in 2021. They serve as a foundational snapshot of my coding journey and demonstrate my experience in building complete applications.
                    </div>
                </div>
                <p className="text-light mt-4 intro-text text-center mx-auto" style={{ maxWidth: '850px', lineHeight: '1.6' }}>
                    Here are some of the projects I have developed, showcasing my experience in building full-stack applications, scalable backend systems, and AI-driven solutions. From designing databases to deploying on cloud infrastructure, I enjoy owning systems end-to-end and turning complex requirements into clean, reliable solutions.
                </p>
                </div>
                <div className="row row-cols-1 row-cols-md-3 g-4 mt-2 mb-2">
                    {
                        projectsInfo.map(project => (
                            <div key={project.id} className="col mt-4">
                                <div onClick={() => openModal(project)} title="View Project Details" className="card h-100 project-card overflow-hidden" data-aos="fade-down" data-aos-delay="50" data-aos-duration="1000" style={{ cursor: "pointer", backgroundColor: "var(--bg-secondary)", border: "1px solid var(--border-subtle)", borderRadius: "var(--radius-md)" }}>
                                    <div className="project-snapshot-wrapper" style={{ height: "200px" }}>
                                        <ProjectSnapshot url={project.link} title={project.title} />
                                    </div>
                                    <div className="card-footer bg-transparent border-0 py-3">
                                        <h4 className="title__color text-center m-0">{project.title}</h4>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    <ProjectDetailsModal key={project.id} modalIsOpen={modalIsOpen} closeModal={closeModal} project={project} />
                </div>
                <div className="text-center mt-4">
                    <button onClick={() => navigate("/projects")} type="button" className="portfolio__btn">More Project <FontAwesomeIcon icon={faAngleDoubleRight} /></button>
                </div>
            </div>
        </section>
    );
};

export default Projects;